import { toast, type ToastOptions } from 'react-toastify';
import { AlertCard } from '../AlertCard';

export interface AlertProps extends ToastOptions {
  notificationType?: string;
  subtitle?: string;
  /** Passed through to AlertCard. */
  templateProps?: any;
  title?: string;
  message: string;
  /** Time to display in alert card. */
  timeString: string;
  severity?: 'info' | 'success' | 'warning' | 'error';
}

/**
 * Show an alert box as a notification.
 */
export function toastAlert(options: AlertProps) {
  const {
    timeString,
    notificationType,
    subtitle,
    templateProps,
    title,
    message,
    severity = 'error',
    ...toastOptions
  } = options;

  toast(
    ({ closeToast }) => (
      <AlertCard
        severity={severity}
        time={timeString}
        notificationType={notificationType}
        title={title}
        subtitle={subtitle}
        message={message}
        templateProps={templateProps}
        onClose={closeToast || (() => void 0)}
      />
    ),
    {
      ...toastOptions,
      className: 'notification-alert-card',
      closeButton: false,
    },
  );
}
